import React from 'react';

/**
 * Social platform icon — ultra-minimal outline style.
 * Supported ids: instagram, linkedin, x, facebook, tiktok, pinterest, youtube
 */
const SocialIcon = ({ id, size = 16, color = 'currentColor' }) => {
  const p = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  switch (id) {
    case 'instagram':
      return (
        <svg {...p}>
          <rect x="2" y="2" width="20" height="20" rx="5"/>
          <circle cx="12" cy="12" r="5"/>
          <circle cx="17.5" cy="6.5" r="1" fill={color} stroke="none"/>
        </svg>
      );
    case 'linkedin':
      return (
        <svg {...p}>
          <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/>
          <rect x="2" y="9" width="4" height="12"/>
          <circle cx="4" cy="4" r="2"/>
        </svg>
      );
    case 'x':
      return (
        <svg {...p}>
          <path d="M4 4l6.5 8L4 20"/>
          <path d="M20 4l-6.5 8L20 20"/>
        </svg>
      );
    case 'facebook':
      return (
        <svg {...p}>
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
        </svg>
      );
    case 'tiktok':
      return (
        <svg {...p}>
          <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/>
        </svg>
      );
    case 'pinterest':
      return (
        <svg {...p}>
          <path d="M12 2a10 10 0 0 0-3.16 19.5c-.07-.63-.13-1.6.03-2.29l1.15-4.88s-.29-.58-.29-1.44c0-1.35.78-2.36 1.75-2.36.83 0 1.23.62 1.23 1.36 0 .83-.53 2.07-.8 3.22-.23.96.48 1.74 1.42 1.74 1.71 0 3.02-1.8 3.02-4.4 0-2.3-1.65-3.9-4.01-3.9-2.73 0-4.33 2.05-4.33 4.16 0 .82.32 1.71.71 2.19.08.1.09.18.07.28l-.27 1.06c-.04.17-.14.21-.33.13-1.24-.58-2.01-2.39-2.01-3.85 0-3.13 2.27-6 6.56-6 3.44 0 6.12 2.46 6.12 5.74 0 3.42-2.16 6.17-5.15 6.17-1.01 0-1.95-.52-2.28-1.14l-.62 2.36c-.22.87-.83 1.96-1.24 2.62A10 10 0 1 0 12 2z"/>
        </svg>
      );
    case 'youtube':
      // v126: rounded rectangle + play triangle
      return (
        <svg {...p}>
          <rect x="2.5" y="4.5" width="19" height="15" rx="3"/>
          <polygon points="10,8.5 16,12 10,15.5" fill={color} stroke="none"/>
        </svg>
      );
    default:
      return <svg {...p}><circle cx="12" cy="12" r="10"/></svg>;
  }
};

export default SocialIcon;
